import { Form } from "antd";
import React from "react";
import Input from "./BaseInput";

const BuyerRemarksField: React.FC = () => {
    return (
        <Form.Item label={<span className="search-field-label">买家留言</span>} name="buyerRemarks">
            <Input allowClear />
        </Form.Item>
    );
};

export default React.memo(BuyerRemarksField);
